<script setup>
import { computed } from 'vue';

const props = defineProps({
  channelType: {
    type: String,
    required: true,
  },
  provider: {
    type: String,
    default: '',
  },
  medium: {
    type: String,
    default: '',
  },
});

const PROVIDER_LABELS = {
  // WhatsApp providers
  whatsapp_cloud: 'WhatsApp Cloud',
  evolution: 'Evolution',
  waha: 'Waha',
  uazapi: 'Uazapi',
  notificame: 'Notificame',
  default: '360Dialog',
  // Email providers
  google: 'Gmail',
  microsoft: 'Outlook',
};

const CHANNEL_TYPE_LABELS = {
  'Channel::WebWidget': 'Web Widget',
  'Channel::FacebookPage': 'Messenger',
  'Channel::TwitterProfile': 'Twitter',
  'Channel::Telegram': 'Telegram',
  'Channel::Api': 'API',
  'Channel::Instagram': 'Instagram',
};

const providerLabel = computed(() => {
  // For WhatsApp channels with specific providers
  if (props.channelType === 'Channel::Whatsapp') {
    if (props.provider && PROVIDER_LABELS[props.provider]) {
      return PROVIDER_LABELS[props.provider];
    }
    return 'WhatsApp';
  }

  // For Email channels with specific providers
  if (props.channelType === 'Channel::Email') {
    if (props.provider && PROVIDER_LABELS[props.provider]) {
      return PROVIDER_LABELS[props.provider];
    }
    return 'IMAP/SMTP';
  }

  // For Voice channels
  if (props.channelType === 'Channel::Voice') {
    return 'Voice';
  }

  // For other channel types
  return CHANNEL_TYPE_LABELS[props.channelType] || '';
});

const shouldShow = computed(() => {
  return providerLabel.value !== '';
});
</script>

<template>
  <span
    v-if="shouldShow"
    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-n-alpha-2 text-n-slate-11 border border-n-weak uppercase tracking-wide"
  >
    {{ providerLabel }}
  </span>
</template>
